import styles from "./styles.module.css";
import { MdAdd } from "react-icons/md";

export default function AddAction({ onClick }) {
  return (
    <div onClick={onClick} className={styles.addAction}>
      <MdAdd style={{ marginRight: 6, fontSize: 24 }} />
      <span>Add</span>
    </div>
  );
}
